/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateMunicipalityDto } from '../models/CreateMunicipalityDto';
import type { MessageResponse } from '../models/MessageResponse';
import type { MunicipalityResponse } from '../models/MunicipalityResponse';
import type { UpdateMunicipalityDto } from '../models/UpdateMunicipalityDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class MunicipalitiesService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Create a municipality account
     * Creates a new municipality user account with assigned commune(s). The user is created with role=MUNICIPALITY and can authenticate via Firebase. At least one geoRegionId must be provided.
     * @returns MunicipalityResponse Municipality created successfully.
     * @throws ApiError
     */
    public municipalityControllerCreate({
        requestBody,
    }: {
        requestBody: CreateMunicipalityDto,
    }): CancelablePromise<MunicipalityResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/municipalities',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `Unauthorized. Bearer token missing or invalid.`,
                403: `Forbidden. Admin role required.`,
                409: `A user with this email already exists.`,
            },
        });
    }
    /**
     * List all municipalities
     * Returns a paginated list of municipalities with their assigned communes.
     * @returns any List of municipalities.
     * @throws ApiError
     */
    public municipalityControllerFindAll({
        page = 1,
        limit = 20,
        search,
    }: {
        /**
         * Page number
         */
        page?: number,
        /**
         * Items per page (max 200)
         */
        limit?: number,
        /**
         * Search by municipality name
         */
        search?: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/municipalities',
            query: {
                'page': page,
                'limit': limit,
                'search': search,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. Admin role required.`,
            },
        });
    }
    /**
     * Get municipality by ID
     * Returns a single municipality with user info and assigned communes.
     * @returns MunicipalityResponse Municipality found.
     * @throws ApiError
     */
    public municipalityControllerFindOne({
        id,
    }: {
        /**
         * Municipality unique identifier
         */
        id: string,
    }): CancelablePromise<MunicipalityResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/municipalities/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. Admin role required.`,
                404: `Municipality not found.`,
            },
        });
    }
    /**
     * Update a municipality
     * Updates municipality name, description, and/or geo region assignments. When geoRegionIds is provided, all existing assignments are replaced.
     * @returns MunicipalityResponse Municipality updated successfully.
     * @throws ApiError
     */
    public municipalityControllerUpdate({
        id,
        requestBody,
    }: {
        /**
         * Municipality unique identifier
         */
        id: string,
        requestBody: UpdateMunicipalityDto,
    }): CancelablePromise<MunicipalityResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/municipalities/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `Unauthorized.`,
                403: `Forbidden. Admin role required.`,
                404: `Municipality not found.`,
            },
        });
    }
    /**
     * Delete a municipality
     * Deletes the municipality record. Reports created by this municipality get municipalityId set to null (the associated user account is preserved).
     * @returns MessageResponse Municipality deleted successfully.
     * @throws ApiError
     */
    public municipalityControllerRemove({
        id,
    }: {
        /**
         * Municipality unique identifier
         */
        id: string,
    }): CancelablePromise<MessageResponse> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/municipalities/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. Admin role required.`,
                404: `Municipality not found.`,
            },
        });
    }
}
